const eventsNSFWNames = {
	safeModeSwitched: 'safe-switch',
};

export default eventsNSFWNames;
